import { useState, useEffect } from "react";
import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import styles from "./EditVatSettingModal.module.css";

const EditVatSettingModal = ({ open, onClose, setting, onSave, saveLoading }) => {
  const [settingValue, setSettingValue] = useState("");
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (setting) {
      const currentVal = setting.field === "EU"
        ? setting.euVat
        : setting.field === "Non-EU"
        ? setting.nonEuVat
        : setting.vat;
      setSettingValue(currentVal || "");
      setReason("");
    }
  }, [setting]);

  const handleSubmit = () => {
    if (!reason.trim()) return;
    onSave({
      settingValue: settingValue.trim(),
      reason: reason.trim(),
      field: setting?.field,
    });
  };

  const displayName = setting
    ? `${setting.product || setting.scenario} — ${setting.field || ""}`
    : "";

  const currentVal = setting?.field === "EU"
    ? setting?.euVat
    : setting?.field === "Non-EU"
    ? setting?.nonEuVat
    : setting?.vat;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Edit VAT Parameter"
      width="520px"
      footer={
        <>
          <button className={styles.cancelBtn} onClick={onClose} disabled={saveLoading}>
            Cancel
          </button>
          <button
            className={styles.saveBtn}
            onClick={handleSubmit}
            disabled={saveLoading || !reason.trim()}
          >
            {saveLoading ? "Saving…" : "Save Changes"}
          </button>
        </>
      }
    >
      <div className={styles.form}>
        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Setting</span>
          <span className={styles.infoValue}>{displayName}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Remarks</span>
          <span className={styles.infoValue}>{setting?.remarks || setting?.description || "—"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>Current Value</span>
          <span className={styles.currentValue}>
            {currentVal === "Derived" ? "Derived" : `${currentVal}%`}
          </span>
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>New Value (%)</label>
          <input
            type="number"
            className={styles.input}
            value={settingValue}
            onChange={(e) => setSettingValue(e.target.value)}
            min="0"
            max="100"
            step="0.01"
            placeholder="Enter new VAT percentage"
          />
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>
            Reason for Change <span className={styles.required}>*</span>
          </label>
          <textarea
            className={styles.textarea}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Mandatory — Describe why this VAT parameter is being changed"
          />
          <span className={styles.fieldHint}>
            This reason will be stored in the audit log for compliance.
          </span>
        </div>
      </div>
    </BaseModal>
  );
};

export default EditVatSettingModal;